<template>
  <DialogueQualityManagement :company-id="companyId" />
</template>

<script>
import DialogueQualityManagement from '@telexpress_auth/vue-dialogue-quality-management/dist/components/DialogueQualityManagement.umd.min';
import '@telexpress_auth/vue-dialogue-quality-management/dist/components/DialogueQualityManagement.css';
import store from '@/store';

export default {
  components: {
    DialogueQualityManagement,
  },
  data() {
    return {
      companyId: ''
    };
  },
  created() {
    this.companyId = store.getters.company;
  },
};
</script>
